import React from 'react';
import CustomTitle from '../../../components/CustomTitle';
import CustomShipmentText from '../../../components/CustomShipmentText';

interface StepsHeadingProps {
  heading: string;
  text: string;
  fontSize?: string;
  textFontSize?: string;
}

/**
 * Onboarding steps heading component
 *
 * Displays a title and description text for onboarding steps
 *
 * @param heading - The heading text
 * @param text - The description text
 * @param fontSize - Optional font size for heading (default: 28px)
 * @param textFontSize - Optional font size for description (default: 14px)
 */
const StepsHeading: React.FC<StepsHeadingProps> = ({
  heading,
  text,
  fontSize,
  textFontSize,
}) => {
  return (
    <div className='steps-heading'>
      <CustomTitle
        className='steps-heading-title'
        text={heading}
        fontSize={fontSize || '28px'}
        fontWeight='700'
        marginBottom='8px'
        lineHeight='40px'
      />

      <CustomShipmentText
        className='steps-heading-text'
        text={text}
        fontSize={textFontSize || '14px'}
        fontWeight='400'
        color='var(--text-primary)'
        lineHeight='24px'
      />
    </div>
  );
};

export default StepsHeading;
